import Button, { BtnColor } from "../../components/Button/Button";
import { Link } from "react-router-dom";
import { useQuery } from "../../utils/useQuery";
import MobileAppSteps from "./MobileAppSteps";
import { useTranslation } from "react-i18next";

const MobileApp = () => {
    const { t } = useTranslation();
    const query = useQuery();

    const step = query.get("step");

    if (step) {
        return <MobileAppSteps step={step} />;
    }

    return (
        <div
            style={{ width: "100%", height: "100%" }}
            className="flex justify-end items-center"
        >
            <div className="flex w-1/2 mr-10 z-10">
                <div>
                    <div className="title mt-12">
                        <span className="font-bold text-2xl">
                            {t(
                                "Welcome to the Cheqit configurator. Showcase your brand with a custom app!"
                            )}
                        </span>
                    </div>
                    <div className="subtitle mt-10">
                        <span className="text-sm">
                            {t(
                                "Personalise your app by adopting one of our pre-configured templates or use our advanced tools to publish your very own custom creation with the colours and fonts of your choice!"
                            )}
                        </span>
                    </div>
                    <div className="button justify-center flex mt-28">
                        <Link to="/chain/app?step=1">
                            <Button color={BtnColor.gray} className="px-20">
                                {t("Start")}
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>

            <div
                style={{
                    position: "absolute",
                    top: "70px",
                    left: "261px",
                    height: "100%",
                    width: "calc(90vw - 430px)",
                    maxWidth: "50vw",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        position: "relative",
                        textAlign: "center",
                        width: "100%",
                        height: "100%",
                        zIndex: "1",
                    }}
                >
                    <div
                        style={{
                            position: "absolute",
                            left: "0",
                            height: "100%",
                            width: "100%",
                            clipPath:
                                "polygon(0 65px, 60% 28%, 100% 100%, 0% 100%)",
                            zIndex: 0,
                            background:
                                "linear-gradient(96.89deg, rgba(219, 60, 195, 0.5) 0%, rgba(65, 63, 224, 0.5) 45.83%, rgba(13, 77, 255, 0.5) 100%)",
                        }}
                    />
                    <div
                        style={{
                            position: "absolute",
                            top: "65px",
                            left: "20px",
                            width: "450px",
                            height: "470px",
                            clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)",
                            background: "rgba(222, 249, 249, 0.49)",
                            transform: "rotate(-8.91deg)",
                        }}
                    />
                    <div
                        style={{
                            position: "absolute",
                            top: "65px",
                            left: "200px",
                            width: "470px",
                            height: "470px",
                            clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)",
                            background: "rgba(222, 249, 249, 0.49)",
                            transform: "rotate(26.66deg)",
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default MobileApp;
